import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useMapEvents } from 'react-leaflet';
import { useBooleanState } from 'shared/hooks/state/boolean';
// This HOC blocks updates to Leaflet-based inner component while user pans or zooms the map
// This fixes strange jumps of objects on map when they get updates while zooming
export function blockUpdateWhileMoving(Component) {
    const wrapper = (props) => {
        const [equalProps, notEqualProps, setEqualProps] = useBooleanState(false);
        const prevProps = useRef();
        useMapEvents({
            zoomstart: setEqualProps,
            movestart: setEqualProps,
            zoomend: notEqualProps,
            moveend: notEqualProps,
            viewreset: notEqualProps,
        });
        useEffect(() => {
            if (props) {
                prevProps.current = props;
            }
        }, [props]);
        // @ts-ignore
        return _jsx(Component, { ...(equalProps ? prevProps.current : props) });
    };
    wrapper.displayName = `blockUpdateWhileMoving<${Component.displayName}>`;
    return wrapper;
}
